import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import SearchInput from "../components/SearchInput";
import { useGetServicesQuery } from "../store/api/servicesApi";

function SkeletonCard() {
  return (
    <div className="flex flex-col rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm animate-pulse">
      <div className="w-full h-48 bg-gray-200" />
      <div className="p-4 flex flex-col gap-3">
        <div className="flex justify-between">
          <div className="h-5 bg-gray-200 rounded w-3/5" />
          <div className="h-6 bg-gray-200 rounded w-16" />
        </div>
        <div className="h-3 bg-gray-100 rounded w-full" />
        <div className="flex gap-3">
          <div className="h-10 bg-gray-100 rounded-xl flex-1" />
          <div className="h-10 bg-gray-200 rounded-xl flex-1" />
        </div>
      </div>
    </div>
  );
}

function Services() {
  const { data, isLoading, isError } = useGetServicesQuery();
  const services = data?.data || [];

  return (
    <div>
      {/* Hero banner */}
      <div className="relative bg-[#1a7b7b]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-10 -right-10 w-52 md:w-72 opacity-80">
            <div style={{
              background: "linear-gradient(135deg, #a8edea 0%, #fed6e3 40%, #c3f0e8 70%, #b8d4f8 100%)",
              borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
              height: "220px",
              filter: "blur(2px)",
              opacity: 0.7,
            }} />
          </div>
        </div>

        <div className="container mx-auto px-4 py-16 md:py-24 flex flex-col items-center gap-6 relative z-10">
          <div className="flex items-center gap-2 text-white/70 font-manrope-regular text-sm">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            <span>/</span>
            <span className="text-white">All services</span>
          </div>
          <h1 className="font-manrope-bold text-[36px] md:text-[56px] text-white text-center">All services</h1>
          <div className="flex justify-center w-full max-w-lg">
            <SearchInput />
          </div>
        </div>
      </div>

      {/* Services grid */}
      <div className="bg-bg py-12 md:py-16">
        <div className="container mx-auto px-4">
          {isError && (
            <div className="text-center py-16">
              <p className="font-manrope-medium text-base text-red-500">Failed to load services. Please try again later.</p>
            </div>
          )}
          {!isError && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {isLoading
                ? Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
                : services.length === 0
                  ? (
                    <div className="col-span-3 text-center py-16">
                      <p className="font-manrope-medium text-base text-secondary">No services available at the moment.</p>
                    </div>
                  )
                  : services.map((service) => <ServiceCard key={service.id} service={service} />)
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Services;
